import { CircleCheck, CircleAlert, Clock } from 'lucide-vue';
import { grauPillColors, reiseterminStateColors } from '@/core/common/helpers/utils';

// Status und Ablehnungsgründe der Country-Manager-Rückmeldungen zu einem Reisetermin

export const CM_STATUS = {
  BESTAETIGT: 'bestaetigt',
  ABGELEHNT: 'abgelehnt',
  ANGEFRAGT: 'angefragt',
  ENTFAELLT: 'entfaellt',
};

// Texte und Icons je CM-Status, die Farben kommen unverändert aus reiseterminStateColors
export const CM_STATUS_DARSTELLUNG = {
  [CM_STATUS.BESTAETIGT]: {
    label: 'CM bestätigt',
    verb: 'bestätigt',
    icon: CircleCheck,
    pill: reiseterminStateColors.CmBestaetigt,
  },
  [CM_STATUS.ABGELEHNT]: {
    label: 'CM abgelehnt',
    verb: 'abgelehnt',
    icon: CircleAlert,
    pill: reiseterminStateColors.CmAbgelehnt,
  },
  [CM_STATUS.ANGEFRAGT]: {
    label: 'CM angefragt',
    verb: 'angefragt',
    icon: Clock,
    pill: reiseterminStateColors.CmAngefragt,
  },
  [CM_STATUS.ENTFAELLT]: {
    label: 'Anfrage entfällt',
    verb: 'entfällt',
    icon: null,
    pill: grauPillColors,
  },
};

export function getCmStatusDarstellung(status) {
  return CM_STATUS_DARSTELLUNG[status] || CM_STATUS_DARSTELLUNG[CM_STATUS.ANGEFRAGT];
}

// Leitet den Status einer Bearbeitung ab
// Eine offene Anfrage entfällt, sobald ein anderer zuständiger CM den Termin abgelehnt hat
export function getCmStatus(bearbeitung, esGibtEineAblehnung = false) {
  if (bearbeitung?.bestaetigt === true) {
    return CM_STATUS.BESTAETIGT;
  }
  if (bearbeitung?.bestaetigt === false) {
    return CM_STATUS.ABGELEHNT;
  }
  return esGibtEineAblehnung ? CM_STATUS.ENTFAELLT : CM_STATUS.ANGEFRAGT;
}

export const REISETERMIN_STATE_ZU_CM_STATUS = {
  CmAngefragt: CM_STATUS.ANGEFRAGT,
  CmBestaetigt: CM_STATUS.BESTAETIGT,
  CmAbgelehnt: CM_STATUS.ABGELEHNT,
};

export const ABLEHNUNGSGRUND_LABEL = {
  SperrzeitOderSaisonalesEreignis: 'Sperrzeit oder saisonales Ereignis',
  ProgrammNichtDurchfuehrbarOderKeineProgrammalternative:
    'Programm nicht durchführbar oder keine Programmalternative',
  Reiseleiterverfuegbarkeit: 'Reiseleiterverfügbarkeit',
};

export function getAblehnungsgrundLabel(grund) {
  return ABLEHNUNGSGRUND_LABEL[grund] || grund || null;
}
